import { render, staticRenderFns } from "./servicesItemElemTpl.vue?vue&type=template&id=0f362984&"
import script from "./servicesItemElemTpl.vue?vue&type=script&lang=js&"
export * from "./servicesItemElemTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports